module.exports = __webpack_public_path__ + "static/media/cal_icon.1e574a9d.svg";